import { Suspense, lazy, useEffect, useState } from "react";
// import MainContent from "src/components/fine_print/tnc31";
import FooterContainer from "src/components/footer/footer";
import SEOContents from "src/components/SEOContents";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import { Helmet } from "react-helmet";
import { theme } from "styled-tools";
import getSchemaData from "src/components/schema";
import { getDamain } from "src/util/commonfun";
import { MetaProps, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { tncPagesSEOData } from "src/config/seo_api";

const structuredData = (brandId) => {

	let domainURL = getDamain(brandId)
	const otherschemaData = getSchemaData('terms-conditions');


	const data = [{
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement":
			[
				{
					"@type": "ListItem",
					"item": `${domainURL}`,
					"name": "Homepage",
					"position": 1
				},
				{
					"@type": "ListItem",
					"item": `${domainURL}/terms-conditions`,
					"name": "T&C",
					"position": 2
				}
			],
		"name": "Breadcrumbs"
	},
	...otherschemaData
	];

	return JSON.stringify(data)
}

interface IProps {
	app: {
		brandId: number;
		type: any;
	};
	theme: any;
	brandName: any
}

const Terms: React.SFC<IProps> = props => {
	const {
		app: { brandId },
		theme
	} = props;
	const { config: { showAPISEOData } } = theme;
	const [seoObjects, setseoObjects] = useState({} as MetaProps);

	//for SEO
	useEffect(() => {
		if (showAPISEOData) {
			const getSeoData = tncPagesSEOData();
			const pathName = "/terms-conditions";

			getSeoData.then(resp => {
				const { objects } = resp;
				const seoData = objects.find((obj: any) => {
					const { metadata = {} } = obj;
					if (metadata.pathname && metadata.pathname === pathName) {
						return obj;
					}

				}) || {};

				const { metadata = {} } = seoData;
				setseoObjects(metadata);

			}).catch(error => console.log(`[${pathName}]:Error in SEO API`))
		}

	}, []);

	const Contents = brandId && brandId === 32 ? lazy(() => import("src/components/fine_print/tnc32")) :
		brandId && (brandId === 39 || brandId === 40) ? lazy(() => import("src/components/fine_print/tnc39")) :
			brandId && (brandId === 46 || brandId === 47) ? lazy(() => import("src/components/fine_print/tnc46")) :
				brandId && (brandId === 61) ? lazy(() => import("src/components/fine_print/tnc61")) :
					lazy(() => import("src/components/fine_print/tnc31"))

	return (<>
		{!showAPISEOData && <Helmet>
			<script type="application/ld+json">
				{
					structuredData(brandId)
				}

			</script>
		</Helmet>}
		{showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}
		<ContentWrapper>
			{!showAPISEOData && <SEOContents pageName={"termsandconditions"} />}
			<Suspense fallback={<div>Loading ... </div>}>
				<Contents />
			</Suspense>
		</ContentWrapper>
		<FooterContainer />
	</>
	);
};

export default withTheme(withAppContext(Terms));

const ContentWrapper = styled.div`
 	max-width: 800px;
	margin: 0 auto;
	font-size: 12px;
	padding: 1.5em 1.25em;
    color: white;
    text-transform: capitalize;
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-top: 1.23em;
	}

	h1 {
		font-size: 18px;
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

	h2 {
		font-size: 16px;
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

	h3 {
		font-size: 14px;
	}

	ul ul,
	ol {
		margin: 1em 0;
        list-style-type:none;
	}

	li {
		margin: 0.75em 0;
	}

	a {
		/* color: #e9d967; */
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
		text-decoration: underline;
        cursor: pointer;
	}
	.policyInternWrap {
		position: relative;
		color: ${theme('palette.nametext')};
	}

	.addColor {
		font-size: 18px;
		/* color: #f4a322; */
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

	
	.policyInternWrap {
		position: relative;
		color: ${theme('palette.nametext')};

		.tittle {
			padding-bottom: 10px;
			margin-bottom: 0;
			border-bottom: 1px solid #876329;
		}
	}

	.downloadAction {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		position: absolute;
		right: 0;
		top: 0;
	}

	.downloadAction a {
		width: 92px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 5px;
		padding: 0;
		border-radius: 5px;
		font-size: 12px;
		color: #fff;
		text-decoration: none;
		background: linear-gradient(180deg, #FFCF84 0%, #AC6700 100%);
	}

	.downloadAction a:hover {
		background: linear-gradient(180deg, #FFCF84 0%, #000000 100%);
	}

	.downloadAction svg {
		width: 12.353px;
		height: 11.25px;
	}

	.brandColor {
		color: #8998F4;
	}

	.bgColor {
		background: #f5f5f5;
		padding: 2rem;
		margin: 0;
		border-radius: 1rem;
	}
	`;
